import { Alert, AlertTitle, Box, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ChangeEvent, useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})
export default function CompanyAvatar({
  label,
  logoUri,
  setValue,
  name,
  acceptedFormats
}: {
  label: string
  logoUri: string
  setValue: UseFormSetValue<any>
  name: string
  acceptedFormats: string
}) {
  const { t } = useTranslation()
  const [avatarBase64, setAvatarBase64] = useState('')
  const [showError, setShowError] = useState(false)

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    setShowError(false)
    const file = event.target.files?.[0]
    if (!file) return

    if (file.size > 3 * 1024 * 1024) {
      setShowError(true)
      return
    }

    const reader = new FileReader()
    reader.onloadend = () => {
      const base64 = reader.result as string
      setValue(name, base64, { shouldDirty: true })
      setAvatarBase64(base64)

      const img = new Image()
      img.onload = () => {
        if (img.width > 400 || img.height > 400) {
          setAvatarBase64('')
          setShowError(true)
          return
        }

        setValue(name, base64, { shouldDirty: true })
        setAvatarBase64(base64)
      }
      img.src = base64
    }

    reader.readAsDataURL(file)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        maxWidth: '21.9375rem'
      }}
    >
      <img
        src={avatarBase64 ? avatarBase64 : logoUri}
        style={{
          width: '21.9375rem',
          height: 'auto',
          border: '1px solid #0000001F',
          padding: '0.625rem'
        }}
      />
      <Button
        component='label'
        color='primary'
        role={undefined}
        variant='text'
        sx={{ width: 'auto' }}
      >
        {label}
        <VisuallyHiddenInput
          type='file'
          onChange={handleFileChange}
          accept={acceptedFormats}
        />
      </Button>
      {showError && (
        <Alert severity='error'>
          <AlertTitle>{t('common.invalid_logo.title')}</AlertTitle>
          {t('common.invalid_logo.description')}
        </Alert>
      )}
    </Box>
  )
}
